import * as ActionTypes from '../components/actions/types';

const initialState = {
  eventDetail: {},
  eventTeams: [],
  eventTeam: {},
  teamGroups: [],
  userTeam: {},
  eventSubmissions: []
};

function eventReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_EVENT_DETAIL: {
      return {
        ...state,
        eventDetail: action.payload.eventDetail
      };
    }
    case ActionTypes.FETCH_EVENT_TEAMS: {
      return {
        ...state,
        eventTeams: action.payload.eventTeams
      };
    }
    case ActionTypes.FETCH_TEAM_GROUPS: {
      return {
        ...state,
        teamGroups: action.payload.teamGroups
      };
    }
    case ActionTypes.FETCH_SINGLE_EVENT_TEAM: {
      return {
        ...state,
        eventTeam: action.payload.eventTeam
      };
    }
    case ActionTypes.FETCH_USER_TEAM: {
      return {
        ...state,
        userTeam: action.payload.userTeam
      };
    }
    case ActionTypes.FETCH_EVENT_SUBMISSIONS: {
      return {
        ...state,
        eventSubmissions: action.payload.eventSubmissions
      };
    }
    case ActionTypes.USER_LOGOUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export default eventReducer;



// WEBPACK FOOTER //
// ./src/reducers/event.js